import {CompanyModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: CompanyModel = {
  id: '',
  nombre: '',
  isCombo: true,
  empresaId: '',
  ...aditionalValues,
}
